import { PrebuildPhase } from "gitpod-next-api/gitpod/v1/prebuild_pb";

/**
 * Checks if a prebuild phase represents an in-progress state.
 * In-progress phases are: PENDING, STARTING, RUNNING, STOPPING, SNAPSHOTTING
 */
export const isInProgressPrebuildPhase = (phase: PrebuildPhase | undefined): boolean => {
    return (
        phase === PrebuildPhase.PENDING ||
        phase === PrebuildPhase.STARTING ||
        phase === PrebuildPhase.RUNNING ||
        phase === PrebuildPhase.STOPPING ||
        phase === PrebuildPhase.SNAPSHOTTING
    );
};
